export default "__VITE_ASSET__C3iJtoQ5__"